import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function PopularCategories() {
  const catIcons: Record<string, string> = {
    romance: 'ri-heart-line',
    fantasy: 'ri-magic-line',
    action: 'ri-sword-line',
    thriller: 'ri-search-eye-line',
    comedy: 'ri-emotion-laugh-line',
    drama: 'ri-movie-line',
    bl: 'ri-genderless-line',
    horror: 'ri-ghost-line',
  };

  const displayCats = categories.filter(c => c.slug !== 'all');

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按喜好快速筛选，发现你的专属韩漫</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {displayCats.map(cat => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-secondary-100 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${catIcons[cat.slug] || 'ri-folder-line'} text-xl text-secondary-600 group-hover:text-primary-600 transition-colors w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}